import {NetworkTypesEnum, TypeLocalNameEnum} from 'domain/usecases';
import {PostOdontoProvidersParams} from 'domain/usecases/private/booking-flow/odonto/post-odonto-providers';
import {makePostOdontoProviders} from 'main/factories/usecases/private/booking-flow/remote-odonto-booking/post-odonto-providers-factory';
import {parseOdontoUnits} from 'presentation/modules/booking/odonto/utils/parseOdontoUnits';
import {removeDuplicates, sortByKey} from 'presentation/utils';

export async function postOdontoProviders(params: PostOdontoProvidersParams) {
	const units = await makePostOdontoProviders().post(params);

	if (!units) {
		return {
			units: [],
			name: NetworkTypesEnum.SELF,
		};
	}

	const parsedUnits = parseOdontoUnits(units);

	const filterDuplicate = removeDuplicates(parsedUnits);
	const sortedUnitsByName = filterDuplicate && sortByKey(filterDuplicate, 'name');
	const sortedUnitsByDistance = filterDuplicate && sortByKey(filterDuplicate, 'distance');
	const shouldSortByDistance =
		params.tpLocalidade?.toUpperCase() === TypeLocalNameEnum.COORDENADAS;

	const unitsFormatted = {
		units: shouldSortByDistance ? sortedUnitsByDistance : sortedUnitsByName,
		name: NetworkTypesEnum.SELF,
	};

	return unitsFormatted;
}
